import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Dob2agePipe } from './pipes/dob2age.pipe';
import { JsonParamPipe } from './pipes/json-param.pipe';
import {ReferralDoctorPipe} from "../referral-manager/pipes/referral-doctor.pipe";
import {FilterTreatmentsPipe} from "../referral-manager/pipes/filter-treatments.pipe";
import {FilterOthTreatmentsPipe} from "../referral-manager/pipes/filter-oth-treatments.pipe";
import {ProviderReferringDoctorPipe} from "../referral-manager/pipes/provider-referring-doctor.pipe";

@NgModule({
    declarations: [
        Dob2agePipe,
        JsonParamPipe,
        ReferralDoctorPipe,
        ProviderReferringDoctorPipe,
        FilterTreatmentsPipe,
        FilterOthTreatmentsPipe,
    ],
    imports: [
        CommonModule,
        FormsModule,
    ],
    exports: [
        Dob2agePipe,
        JsonParamPipe,
        ReferralDoctorPipe,
        ProviderReferringDoctorPipe,
        FilterTreatmentsPipe,
        FilterOthTreatmentsPipe,
    ],
    providers: [
        Dob2agePipe,
        JsonParamPipe,
    ]
})
export class TDOPipesModule { }
